import {
  CrashBetRecordsBetItem,
  CrashGameRankItem,
  CrashLatestGameItem,
} from '@/apis/casino/crash';

export interface CrashGameItem {
  id: string;
  status: GameStatus;
  multiplier: number | null;
  crashpoint: number;
  startTime: string;
  leaderboard: GameMemberItem[];
  hash: {
    id: string;
    hash: string;
    number: number;
  };
  seed: {
    id: string;
    seed: string;
  };
}

export interface CrashHistoryItem {
  hash: string;
  id: string;
  result: string;
  roundId: string;
  seed: string;
  startTime: string;
}

interface User {
  id: string;
  name: string;
}

export interface GameMemberItem {
  id: string;
  user: User | null;
  gameId: string;
  amount: number; //bet amount
  btcAmount: number;
  payoutMultiplier: number;
  payout: number; //win amount
  currency: string;
  result: string;
  updateAt: string;
  crashoutAt: number;
}

export interface ShowGameMemberItem extends CrashBetRecordsBetItem {
  showPlayer: string;
  showMultiplier: string;
  showBet: string;
  showProfit: string;
  isCurrentUser?: boolean;
}

export enum GameStatus {
  Init = 0,
  Start = 1, // START
  InProgress = 2, // IN_PROGRESS
  Crash = 3, // 'crash',
  Starting = 4, //'starting',
  Pending = 5, // 'pending',
}

export interface CrashWsMsg {
  id: string;
  gameId: string;
  roundId: number;
  status: GameStatus;
  multiplier: number;
  startTime: string;
  timestamp: string;
  elapsed: number;
  nextRoundIn: number;
  crashedIn: GameMemberItem[];
  crashedOut: GameMemberItem[];
}

export interface BetParams {
  amount: number;
  payoutMultiplier: number;
  currency: string;
}
